'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFlagsAndNotes = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _constants = require('../constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getFlagsAndNotes = exports.getFlagsAndNotes = function getFlagsAndNotes(attributesValues, customAttributes) {
  var flagsIds = R.propOr([], 'flags', customAttributes);
  var notesIds = R.propOr([], 'notes', customAttributes);

  return R.addIndex(R.reduce)(function (acc, id, index) {
    if (!R.has(id, attributesValues)) {
      return acc;
    }
    var attr = R.pick(['id', 'name', 'value', 'display'], R.prop(id, attributesValues));
    if (R.isNil(attr.value) || !R.pathOr(true, ['value', 'display'], attr) || !R.propOr(true, 'display', attr) || R.includes(R.path(['value', 'id'], attr), _constants.REJECTED_VALUE_IDS)) {
      return acc;
    }
    return R.append(index < flagsIds.length ? R.assoc('code', R.path(['value', 'id'], attr), attr) : attr, acc);
  }, [], R.concat(flagsIds, notesIds));
};